"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
/* ++++++++++ --------------- ACCORDION : DEFINITION --------------- ++++++++++ */

var _default2 = {
  name: 'Accordion',
  props: {
    icon: {
      type: 'string',
      default: 'tasks'
    },
    title: {
      type: 'object',
      default: 'Title'
    },
    nowrap: {
      type: 'boolean',
      default: true,
      options: [true, false]
    },
    static: {
      type: 'boolean',
      default: true,
      options: [true, false]
    },
    contents: {
      type: 'object',
      default: 'Contents'
    },
    handleLink: {
      type: 'function',
      default: function _default(e, active) {
        console.log('link clicked: ', e);
        console.log('accordion open: ', active);
      }
    },
    handleToggle: {
      type: 'function',
      default: function _default(e, active) {
        console.log('toggle accordion: ', e);
        console.log('accordion open: ', active);
      }
    }
  }
};
exports.default = _default2;